import { Dashboard } from '@/pages/dashboard';
import { OrderList } from '@/pages/orders/list';
import { UsersList } from '@/pages/users/list';
import { UserCreate } from '@/pages/users/create';
import { UserEdit } from '@/pages/users/edit';
import { CustomersList } from '@/pages/customers/list';
import { CustomerCreate } from '@/pages/customers/create';
import { CustomerEdit } from '@/pages/customers/edit';
import { CustomersView } from '@/pages/customers/view';
import { PricingPoliciesCreate } from '@/pages/pricing-policies/create';
import { PricingPoliciesEdit } from '@/pages/pricing-policies/edit';
import { PricingPoliciesList } from '@/pages/pricing-policies/list';
import { LimitPoliciesList } from '@/pages/limit-policies/list';
import { LimitPoliciesCreate } from '@/pages/limit-policies/create';
import { LimitPoliciesEdit } from '@/pages/limit-policies/edit';
import { CampaignsList } from '@/pages/campaigns/list';
import { CampaignsCreate } from '@/pages/campaigns/create';
import { CampaignsEdit } from '@/pages/campaigns/edit';
import { VouchersList } from '@/pages/vouchers/list';
import { VouchersCreate } from '@/pages/vouchers/create';
import { VouchersEdit } from '@/pages/vouchers/edit';
import { ScenariosList } from '@/pages/scenarios/list';
import { ScenariosCreate } from '@/pages/scenarios/create';
import { ScenariosEdit } from '@/pages/scenarios/edit';
import { ContractsList } from '@/pages/contracts/list';
import { ContractsCreate } from '@/pages/contracts/create';
import { ContractsEdit } from '@/pages/contracts/edit';
import { VehiclesList } from '@/pages/vehicles/list';
import { VehiclesCreate } from '@/pages/vehicles/create';
import { VehiclesEdit } from '@/pages/vehicles/edit';
import { GatesList } from '@/pages/gates/list';
import { GatesCreate } from '@/pages/gates/create';
import { GatesEdit } from '@/pages/gates/edit';
import { TariffsList } from '@/pages/tariffs/list';
import { TariffsCreate } from '@/pages/tariffs/create';
import { TariffsEdit } from '@/pages/tariffs/edit';
import { ParkingSessionsList } from '@/pages/parking-sessions/list';
import { ParkingSessionsCreate } from '@/pages/parking-sessions/create';
import { ParkingSessionsEdit } from '@/pages/parking-sessions/edit';
import { ReportsCatalog } from '@/pages/reports/catalog';
import { ReportViewer } from '@/pages/reports/viewer';
import TestDialogPage from '@/pages/test-dialog';
import { GateMonitor } from '@/pages/gate-monitor';
import { SettingsPage } from '@/pages/settings';
import { VectroResource, VectroResourceType } from '@/resources/resource-types';

export type ResourceAction = 'list' | 'create' | 'edit' | 'show';

export type ResourceDeclaration = {
	path: string;
	element: React.ReactNode;
};

type MetaDeclaration = {
	label?: string;
	icon?: React.ReactNode;
};

type ResourceConfigEntry = {
	name: VectroResourceType;
	meta?: MetaDeclaration;
} & Partial<Record<ResourceAction, ResourceDeclaration>>;

export const resourceRegistry: Record<VectroResourceType, ResourceConfigEntry> =
	{
		dashboard: {
			name: VectroResource.dashboard,
			list: {
				path: '/',
				element: <Dashboard />
			},
			meta: { label: 'Dashboard' }
		},
                users: {
                        name: VectroResource.users,
                        list: {
                                path: '/users',
                                element: <UsersList />
                        },
                        create: {
                                path: '/users/create',
                                element: <UserCreate />
                        },
                        edit: {
                                path: '/users/edit/:id',
                                element: <UserEdit />
                        },
                        meta: { label: 'Users' }
                },
                customers: {
                        name: VectroResource.customers,
                        list: {
                                path: '/customers',
                                element: <CustomersList />
                        },
                        create: {
                                path: '/customers/create',
                                element: <CustomerCreate />
                        },
                        edit: {
                                path: '/customers/edit/:id',
                                element: <CustomerEdit />
                        },
                        show: {
                                path: '/customers/view/:id',
                                element: <CustomersView />
                        },
                        meta: { label: 'Customers' }
                },
                orders: {
                        name: VectroResource.orders,
			list: {
				path: '/orders',
				element: <OrderList />
			},
			meta: { label: 'Orders' }
		},
                pricingPolicies: {
                        name: VectroResource.pricingPolicies,
                        list: {
                                path: '/pricing-policies',
                                element: <PricingPoliciesList />
                        },
                        create: {
                                path: '/pricing-policies/create',
                                element: <PricingPoliciesCreate />
                        },
                        edit: {
                                path: '/pricing-policies/edit/:id',
                                element: <PricingPoliciesEdit />
                        },
                        meta: { label: 'Pricing Policies' }
                },
                limitPolicies: {
                        name: VectroResource.limitPolicies,
                        list: {
                                path: '/limit-policies',
                                element: <LimitPoliciesList />
                        },
                        create: {
                                path: '/limit-policies/create',
                                element: <LimitPoliciesCreate />
                        },
                        edit: {
                                path: '/limit-policies/edit/:id',
                                element: <LimitPoliciesEdit />
                        },
                        meta: { label: 'Limit Policies' }
                },

		scenarios: {
			name: VectroResource.scenarios,
			list: {
				path: '/scenarios',
				element: <ScenariosList />
			},
			create: {
				path: '/scenarios/create',
				element: <ScenariosCreate />
			},
			edit: {
				path: '/scenarios/edit/:id',
				element: <ScenariosEdit />
			},
			meta: { label: 'Scenarios' }
		},
		rateTypes: {
			name: VectroResource.rateTypes
		},
		campaigns: {
			name: VectroResource.campaigns,
			list: {
				path: '/campaigns',
				element: <CampaignsList />
			},
			create: {
				path: '/campaigns/create',
				element: <CampaignsCreate />
			},
			edit: {
				path: '/campaigns/edit/:id',
				element: <CampaignsEdit />
			},
			meta: { label: 'Campaigns' }
		},
                vouchers: {
                        name: VectroResource.vouchers,
                        list: {
                                path: '/vouchers',
                                element: <VouchersList />
                        },
                        create: {
                                path: '/vouchers/create',
                                element: <VouchersCreate />
                        },
                        edit: {
                                path: '/vouchers/edit/:id',
                                element: <VouchersEdit />
                        },
                        meta: { label: 'Vouchers' }
                },
                contracts: {
                        name: VectroResource.contracts,
                        list: {
                                path: '/contracts',
                                element: <ContractsList />
                        },
                        create: {
                                path: '/contracts/create',
                                element: <ContractsCreate />
                        },
                        edit: {
                                path: '/contracts/edit/:id',
                                element: <ContractsEdit />
                        },
                        meta: { label: 'Contracts' }
		},
		vehicles: {
			name: VectroResource.vehicles,
			list: {
				path: '/vehicles',
				element: <VehiclesList />
			},
			create: {
				path: '/vehicles/create',
				element: <VehiclesCreate />
			},
			edit: {
				path: '/vehicles/edit/:id',
				element: <VehiclesEdit />
			},
			meta: { label: 'Vehicles' }
		},
		parkingSessions: {
			name: VectroResource.parkingSessions,
			list: {
				path: '/parking-sessions',
				element: <ParkingSessionsList />
			},
			create: {
				path: '/parking-sessions/create',
				element: <ParkingSessionsCreate />
			},
			edit: {
				path: '/parking-sessions/edit/:id',
				element: <ParkingSessionsEdit />
			},
			meta: { label: 'Parking Sessions' }
		},
                gateMonitor: {
                        name: VectroResource.gateMonitor,
                        list: {
                                path: '/gate-monitor',
                                element: <GateMonitor />
                        },
                        meta: { label: 'Gate Monitor' }
                },
                gates: {
                        name: VectroResource.gates,
                        list: {
                                path: '/gates',
                                element: <GatesList />
                        },
                        create: {
                                path: '/gates/create',
                                element: <GatesCreate />
                        },
                        edit: {
                                path: '/gates/edit/:id',
                                element: <GatesEdit />
                        },
                        meta: { label: 'Gates' }
                },
                tariffs: {
                        name: VectroResource.tariffs,
                        list: {
                                path: '/tariffs',
                                element: <TariffsList />
                        },
                        create: {
                                path: '/tariffs/create',
                                element: <TariffsCreate />
                        },
                        edit: {
                                path: '/tariffs/edit/:id',
                                element: <TariffsEdit />
                        },
                        meta: { label: 'Tariffs' }
                },
                reports: {
                        name: VectroResource.reports,
                        list: {
                                path: '/reports',
                                element: <ReportsCatalog />
                        },
                        show: {
                                path: '/reports/:reportKey',
                                element: <ReportViewer />
                        },
                        meta: { label: 'Reports' }
                },
        };

export type ResourceRoute = { path: string; element: React.ReactNode };

export const resourceRoutes: ResourceRoute[] = Object.values(
	resourceRegistry
).reduce<ResourceRoute[]>((acc, resource) => {
	if (resource.list) {
		acc.push({
			path: resource.list.path,
			element: resource.list.element
		});
	}
	if (resource.create) {
		acc.push({
			path: resource.create.path,
			element: resource.create.element
		});
	}
	if (resource.edit) {
		acc.push({
			path: resource.edit.path,
			element: resource.edit.element
		});
	}
	if (resource.show) {
		acc.push({
			path: resource.show.path,
			element: resource.show.element
		});
	}
	return acc;
}, []);

// Add test dialog route
resourceRoutes.push({
	path: '/test-dialog',
	element: <TestDialogPage />
});

// Add settings route
resourceRoutes.push({
	path: '/settings',
	element: <SettingsPage />
});

export const getResourceRoute = (
	resource: string,
	action: ResourceAction
): ResourceDeclaration | undefined => {
	const entry = resourceRegistry[resource as VectroResourceType];

	if (!entry) {
		return undefined;
	}

	return entry[action];
};
